import axiosInstance from '../lib/axios'
import { API_ENDPOINTS } from '../constants/api'

interface ResetPayload {
  new_password: string
  force_logout: boolean
}

export interface PasswordResetResponse {
  success: boolean
  message: string
  user_id: number
  user_name: string
  email: string | null
  force_logout: boolean
}

export const platformPasswordResetService = {
  async resetOrgUser(orgId: number, userId: number, payload: ResetPayload): Promise<PasswordResetResponse> {
    const { data } = await axiosInstance.post<PasswordResetResponse>(
      API_ENDPOINTS.PLATFORM_RESET_ORG_USER(orgId, userId), payload,
    )
    return data
  },

  async resetPropertyAdmin(orgId: number, propId: number, payload: ResetPayload): Promise<PasswordResetResponse> {
    const { data } = await axiosInstance.post<PasswordResetResponse>(
      API_ENDPOINTS.PLATFORM_RESET_PROPERTY_ADMIN(orgId, propId), payload,
    )
    return data
  },

  async resetPlatformAdmin(adminId: number, payload: ResetPayload): Promise<PasswordResetResponse> {
    const { data } = await axiosInstance.post<PasswordResetResponse>(
      API_ENDPOINTS.PLATFORM_RESET_PLATFORM_ADMIN(adminId), payload,
    )
    return data
  },
}
